module.exports = __webpack_public_path__ + "static/media/bot_no_bg_portrait.aeb0fd1b.png";